import { colors, getStrength } from '@/auth/constants/passwordRequirements';

export function validatePassword(value: string, confirmValue: string) {
	const passwordStrength = getStrength(value);
	const passwordColor =
		passwordStrength === 100 ? colors.Success : passwordStrength > 50 ? colors.Warning : colors.Error;

	const doesConfirmMatch = !!value?.length && !!confirmValue?.length && value === confirmValue;
	const confirmStrength = doesConfirmMatch ? 100 : 50;
	const confirmColor = doesConfirmMatch ? colors.Success : colors.Error;

	return {
		passwordColor,
		passwordStrength,
		value,
		confirmColor,
		confirmStrength,
		doesConfirmMatch,
	};
}
